export var formatProgramThumbnailTitle = function formatProgramThumbnailTitle(_ref) {
  var country = _ref.country,
      city = _ref.city;
  if (!country) return city;
  if (!city) return country;
  return country + " - " + city;
};